export default __webpack_public_path__ + "static/media/icon-coin-joe.ee9583da.svg";